import { createSelector } from '@reduxjs/toolkit'
import { getFrees } from 'model/selectors/base'
import orderBy from 'lodash/orderBy'

export const getSortedFreeCourses = createSelector([getFrees], courses => {
  return orderBy(courses, 'createdAt', 'desc')
})
